import React from 'react';
import { Image, ImageProps } from '@cp/ds/src/components/image';
import { styled } from '@cp/ds/src/theme';
import { toAsset, withWebp } from '@cp/shared/image';
import img from './assets/gift.png';
import imgWebp from './assets/gift.webp';

const Img = styled(Image)({
  borderRadius: '50%',
  overflow: 'hidden',
});

export interface GiftImageProps extends Partial<ImageProps> {
  size?: number;
}

export const GiftImage: React.FC<GiftImageProps> = ({ size = 313, ...props }) => (
  <Img alt="Подарок" asset={withWebp(toAsset(img))(imgWebp)} height={size} width={size} {...props} />
);
